import React from 'react';

import { MediaSourcesSettings } from 'js/src/components/app/doc-to-script/MediaSourcesSettings';
import { PrimaryButton } from 'js/src/components/common/ui/Button';
import Modal, { MODAL_SIZES } from 'js/src/components/common/ui/modal';

type MediaSourcesModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

export const MediaSourcesModal: React.FC<MediaSourcesModalProps> = ({ isOpen, onClose }) => {
    return (
        <Modal
            showing={isOpen}
            onHidden={onClose}
            title="Media recommendation settings"
            size={MODAL_SIZES.DEFAULT}
            closeable={true}
            footer={<PrimaryButton text="Done" onClick={onClose} />}
        >
            <MediaSourcesSettings />
        </Modal>
    );
};
